import { useEffect, useState } from "react";
import { Trophy, Zap } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;
const GOLD = "#C9A84C";

export const brzycki1RM = (kg, reps) => {
  if (!kg || kg <= 0 || !reps || reps <= 0 || reps >= 37) return null;
  if (reps === 1) return kg;
  return (kg * 36) / (37 - reps);
};

const fmtKg = (v) => {
  const r = Math.round(v * 10) / 10;
  return Number.isInteger(r) ? String(r) : r.toFixed(1).replace(".", ",");
};

export default function PrestatieBlok({ naam, token, huidigeSets = [] }) {
  const [besteSet, setBesteSet] = useState(undefined);

  useEffect(() => {
    if (!naam || !token) { setBesteSet(null); return; }
    let actief = true;
    fetch(`${API}/api/workout/exercise-record?naam=${encodeURIComponent(naam)}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(r => (r.ok ? r.json() : { beste_set: null }))
      .then(d => { if (actief) setBesteSet(d.beste_set || null); })
      .catch(() => { if (actief) setBesteSet(null); });
    return () => { actief = false; };
  }, [naam, token]);

  let beste1RM = null;
  for (const s of huidigeSets) {
    const kg = parseFloat(s.kg ?? s.weight);
    const reps = parseInt(s.reps, 10);
    const rm = brzycki1RM(kg, reps);
    if (rm !== null && (beste1RM === null || rm > beste1RM)) beste1RM = rm;
  }

  return (
    <div data-testid="prestaties-blok" className="pt-3 border-t border-white/6">
      <p className="text-zinc-500 text-xs uppercase tracking-widest font-bold mb-2.5 flex items-center gap-1.5">
        <Trophy size={11} style={{ color: GOLD }} /> Jouw prestaties
      </p>
      <div className="grid grid-cols-2 gap-2">
        <div className="rounded-xl p-3" style={{ background: "rgba(201,168,76,0.06)", border: "1px solid rgba(201,168,76,0.15)" }}>
          <p className="text-zinc-500 text-[10px] uppercase tracking-widest font-bold mb-1">Beste set ooit</p>
          {besteSet === undefined ? (
            <p className="text-zinc-600 text-sm">…</p>
          ) : besteSet ? (
            <p data-testid="beste-set-ooit" className="text-white font-bold text-sm">
              {fmtKg(besteSet.kg)} kg <span className="text-zinc-400 font-semibold">× {besteSet.reps} reps</span>
            </p>
          ) : (
            <p data-testid="beste-set-ooit" className="text-zinc-500 text-xs italic leading-snug">Nog geen eerdere prestaties</p>
          )}
        </div>
        <div className="rounded-xl p-3" style={{ background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.08)" }}>
          <p className="text-zinc-500 text-[10px] uppercase tracking-widest font-bold mb-1 flex items-center gap-1">
            <Zap size={9} style={{ color: GOLD }} /> Geschatte 1RM vandaag
          </p>
          {beste1RM !== null ? (
            <p data-testid="geschatte-1rm-vandaag" className="text-white font-bold text-sm">± {fmtKg(beste1RM)} kg</p>
          ) : (
            <p data-testid="geschatte-1rm-vandaag" className="text-zinc-500 text-xs italic leading-snug">Vul een set in om je 1RM te zien</p>
          )}
        </div>
      </div>
    </div>
  );
}
